export const CATEGORY_INPUT = {
  CATEGORY_CREATION_FAILED: {
    key: 'CATEGORY_CREATION_FAILED',
    value: 'Category creation failed',
  },
  CREATE_CATEGORY: {
    key: 'CREATE_CATEGORY',
    value: 'Create Category',
  },
  CATEGORY_NAME_REQUIRED: {
    key: 'CATEGORY_NAME_REQUIRED',
    value: 'Category name is required',
  },
  ENTER_CATEGORY_NAME: {
    key: 'ENTER_CATEGORY_NAME',
    value: 'Enter category name',
  },
  CREATE_BUTTON: {
    key: 'CREATE_BUTTON',
    value: 'Create',
  },
  FETCH_CATEGORIES_FAILED: {
    key: 'FETCH_CATEGORIES_FAILED',
    value: 'Failed to fetch categories',
  },
  CATEGORY_UPDATED_SUCCESS: {
    key: 'CATEGORY_UPDATED_SUCCESS',
    value: 'Category updated successfully',
  },
  CATEGORY_UPDATE_FAILED: {
    key: 'CATEGORY_UPDATE_FAILED',
    value: 'Failed to update the category',
  },
  CATEGORY_LABEL: {
    key: 'CATEGORY_LABEL',
    value: 'Category',
  },
  ADD_NEW_BUTTON: {
    key: 'ADD_NEW_BUTTON',
    value: '+ Add New',
  },
  SELECT_CATEGORY_PLACEHOLDER: {
    key: 'SELECT_CATEGORY_PLACEHOLDER',
    value: 'Select a category',
  },
};
